import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaDollarSign, FaArrowRight } from 'react-icons/fa';
import { destinations } from '../data/destinationsData';
import './StudyDestinations.css';

const StudyDestinations = () => {
    const [selectedDestination, setSelectedDestination] = useState(null);

    return (
        <section className="destinations-section section">
            <div className="container">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="section-title"
                >
                    <h2>
                        Popular Study <span className="gradient-text">Destinations</span>
                    </h2>
                    <p>Explore world-class education opportunities across the globe</p>
                </motion.div>

                <div className="destinations-grid">
                    {destinations.map((destination, index) => (
                        <motion.div
                            key={destination.id}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            className="destination-card"
                            onClick={() => setSelectedDestination(destination)}
                        >
                            <div className="destination-image">
                                <img src={destination.image} alt={destination.country} />
                                <div className="destination-overlay">
                                    <div className="overlay-badge">
                                        <FaMapMarkerAlt />
                                        <span>{destination.popularCities.length} Cities</span>
                                    </div>
                                </div>
                            </div>

                            <div className="destination-content">
                                <h3>{destination.country}</h3>
                                <p>{destination.description}</p>

                                <div className="destination-info">
                                    <div className="info-item">
                                        <FaDollarSign className="info-icon" />
                                        <div>
                                            <span className="info-label">Tuition</span>
                                            <span className="info-value">{destination.averageTuition}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="destination-highlights-list">
                                    {destination.highlights.slice(0, 2).map((highlight, idx) => (
                                        <div key={idx} className="highlight-tag">
                                            ✓ {highlight}
                                        </div>
                                    ))}
                                </div>

                                <button className="btn-explore">
                                    Explore More <FaArrowRight />
                                </button>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>

            {/* Modal for detailed view */}
            {selectedDestination && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="destination-modal"
                    onClick={() => setSelectedDestination(null)}
                >
                    <motion.div
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.8, opacity: 0 }}
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="modal-close"
                            onClick={() => setSelectedDestination(null)}
                        >
                            ×
                        </button>

                        <div className="modal-image">
                            <img src={selectedDestination.image} alt={selectedDestination.country} />
                            <div className="modal-image-overlay">
                                <h2>{selectedDestination.country}</h2>
                            </div>
                        </div>

                        <div className="modal-body">
                            <h3>{selectedDestination.title}</h3>
                            <p className="modal-description">{selectedDestination.description}</p>

                            <div className="modal-section">
                                <h4>Why Choose {selectedDestination.country}?</h4>
                                <div className="highlights-grid">
                                    {selectedDestination.highlights.map((highlight, idx) => (
                                        <div key={idx} className="modal-highlight">
                                            <div className="highlight-check">✓</div>
                                            <span>{highlight}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="modal-section">
                                <h4>Popular Cities</h4>
                                <div className="cities-list">
                                    {selectedDestination.popularCities.map((city, idx) => (
                                        <div key={idx} className="city-tag">
                                            <FaMapMarkerAlt /> {city}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="modal-footer">
                                <div className="footer-info">
                                    <FaDollarSign className="footer-icon" />
                                    <div>
                                        <span className="footer-label">Average Tuition</span>
                                        <span className="footer-value">{selectedDestination.averageTuition}</span>
                                    </div>
                                </div>
                                <button className="btn btn-primary">
                                    Apply Now <FaArrowRight />
                                </button>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </section>
    );
};

export default StudyDestinations;
